import './Helpers.scss';

import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import { HelperPopper } from 'primary/helpers/HelperPopper';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';

export const RandomTeamsHelper = () => {
  const t = useTranslate();
  return (
    <HelperPopper color={'white'}>
      <div className={'helpers -helperTypeEvent'}>
        <KeyValue
          accent
          alignStart
          keyValue={t('helpers.events.freeRegister.freeKey')}
          value={t('helpers.events.randomTeams.notice')}
        />
        <KeyValue
          accent
          alignStart
          keyValue={t(`helpers.events.freeRegister.notFreeKey`)}
          value={t('helpers.events.classicTeams.notice')}
        />
        <p>{}</p>
      </div>
    </HelperPopper>
  );
};
